module.exports = __webpack_public_path__ + "img/telegram.8dd60978.png";